import React, { useEffect, useState, useCallback } from 'react'
import Swal from 'sweetalert2';
import { connect, useSelector } from 'react-redux';
import { getNotificationsAddressee, viewNotification, deleteNotification } from '../../actions/notificationsActions'
import { acceptFriendRequest, cancelFriendRequest } from '../../actions/friendsActions'
import inMemoryJWT from '../../auth/inMemoryJwt';
import { acceptCommunityRequest, cancelCommunityRequest, manageSocialRoom } from '../../actions/userActions'
import { useHistory } from "react-router-dom";
import Notifications from '../../containers/Navbar/Notifications/Notifications';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1000
})

const ModalNotification = ({ isProfessionalUser, acceptCommunityRequest, cancelCommunityRequest,
    manageSocialRoom, deleteNotification, viewNotification, setNotification, acceptFriendRequest,
    cancelFriendRequest, getNotificationsAddressee, setIsShowNotification,displayModal, typeModal = "",
    relationBetween }) => {
    const history = useHistory()
    const close  = (e) => {
        setIsShowNotification(false)
    }
    const divStyle = {
        display: displayModal ? 'block' : 'none'
    }

    const [isViewNotification, setisViewNotification] = useState({})
    const [FriendsResponse, setFriendsResponse] = useState({})

    // listNotificationsAddresse: state.notifications.listNotificationsAddresse,
     const {listNotificationsAddresse,isLoadingNotificationsAddresse} = useSelector(state=>state.notifications)

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            getNotificationsAddressee(isProfessionalUser)
        })
    }, [])

    const SetNotification = useCallback(
        () => {
            setisViewNotification({})
            if (!isLoadingNotificationsAddresse) {
                if (listNotificationsAddresse.othersNotifications && listNotificationsAddresse.request) {
                    for (let index = 0; index < listNotificationsAddresse.othersNotifications.length; index++) {
                        if (listNotificationsAddresse.othersNotifications[index].doYouSeeTheNotification) {
                            setisViewNotification(prevState => { return { ...prevState, [listNotificationsAddresse.othersNotifications[index]._id]: true } })
                        } else {
                            setisViewNotification(prevState => { return { ...prevState } })
                        }
                    }
                }

            }
        }, [isLoadingNotificationsAddresse]
    )

    useEffect(() => {
        SetNotification()
    }, [SetNotification])
    /* (listNotificationsAddresse.othersNotifications.length - Object.keys(isViewNotification).length) + listNotificationsAddresse.request.length)  */
    useEffect(() => {
        {
            !isLoadingNotificationsAddresse &&
                setNotification(listNotificationsAddresse.length)

        }
    }, [listNotificationsAddresse])//isViewNotification TODO

    return (
        <Notifications
            listNotifications={listNotificationsAddresse || []}
            isLoadingNotificationsAddresse={isLoadingNotificationsAddresse}
            setisViewNotification={setisViewNotification}
            isProfessionalUser={isProfessionalUser}
            isViewNotification={isViewNotification}
            viewNotification={viewNotification}
            setIsShowNotification={setIsShowNotification}
            
        />)
}

const mapStateToProps = (state) => {
    return {
        //isLoadingNotificationsAddresse: state.notifications.isLoadingNotificationsAddresse,
       
        relationBetween: state.userInfo.relationBetween,
    }
}

export default connect(mapStateToProps, { getNotificationsAddressee, deleteNotification, manageSocialRoom, acceptCommunityRequest, cancelCommunityRequest, viewNotification, acceptFriendRequest, cancelFriendRequest })(ModalNotification)
